// Status helpers + Start/Stop button rendering.

import { els } from "./dom.js";
import { t } from "./i18n.js";

export function isProcessActiveState(state) {
  return state === "connecting" || state === "connected" || state === "speaking";
}

export function renderStartStopButton(active) {
  if (!els.connectBtn) return;
  if (active) {
    els.connectBtn.dataset.state = "active";
    els.connectBtn.textContent = t("controls.stop");
  } else {
    els.connectBtn.dataset.state = "";
    els.connectBtn.textContent = t("controls.start");
  }
}

export function setState(state, line) {
  if (els.statusDot) els.statusDot.dataset.state = state;
  if (els.dbgState) els.dbgState.textContent = state;
  if (line !== undefined && els.statusLine) els.statusLine.textContent = line;
  renderStartStopButton(isProcessActiveState(state));
}

export function setWorkflowControlsEnabled(enabled) {
  if (els.prevStepIndicator) els.prevStepIndicator.disabled = !enabled;
  if (els.nextStepIndicator) els.nextStepIndicator.disabled = !enabled;
}

export function appendMessage(kind, text) {
  if (!els.chatLog) return null;
  const div = document.createElement("div");
  div.className = `msg ${kind}`;
  div.textContent = text;
  els.chatLog.appendChild(div);
  els.chatLog.scrollTop = els.chatLog.scrollHeight;
  return div;
}
